import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/huyenpvd/domains/caocaoadventures/caocaoadventures_v2/node_modules/next/dist/client/app-dir/link.js");
